const FEATURE_DEFINITIONS = {
    bp_delta: {
        label: 'Bandpower: Delta',
        shortLabel: 'Delta power',
        description: 'Mean Welch power spectral density in the delta band, 1-4 Hz.'
    },
    bp_theta: {
        label: 'Bandpower: Theta',
        shortLabel: 'Theta power',
        description: 'Mean Welch power spectral density in the theta band, 4-8 Hz.'
    },
    bp_alpha: {
        label: 'Bandpower: Alpha',
        shortLabel: 'Alpha power',
        description: 'Mean Welch power spectral density in the alpha band, 8-13 Hz.'
    },
    bp_beta: {
        label: 'Bandpower: Beta',
        shortLabel: 'Beta power',
        description: 'Mean Welch power spectral density in the beta band, 13-30 Hz.'
    },
    bp_gamma: {
        label: 'Bandpower: Gamma',
        shortLabel: 'Gamma power',
        description: 'Mean Welch power spectral density in the gamma band, 30-80 Hz.'
    },
    entropy: {
        label: 'Shannon Entropy',
        shortLabel: 'Entropy',
        description: 'Shannon entropy of the channel time series amplitude distribution.'
    },
    fooof_offset: {
        label: 'FOOOF: Aperiodic Offset',
        shortLabel: 'FOOOF offset',
        description: 'Aperiodic offset from the FOOOF power-spectrum model; reflects broadband power level.'
    },
    fooof_exponent: {
        label: 'FOOOF: Aperiodic Exponent',
        shortLabel: 'FOOOF exponent',
        description: 'Aperiodic exponent from FOOOF; describes the 1/f spectral slope.'
    },
    fooof_r2: {
        label: 'FOOOF: Model R-squared',
        shortLabel: 'FOOOF R2',
        description: 'Goodness of fit for the FOOOF model, reported as R-squared.'
    },
    fooof_err: {
        label: 'FOOOF: Fit Error',
        shortLabel: 'FOOOF error',
        description: 'FOOOF model reconstruction error for the channel power spectrum.'
    },
    fooof_n_peaks: {
        label: 'FOOOF: Number of Peaks',
        shortLabel: 'FOOOF peaks',
        description: 'Number of oscillatory peaks identified by FOOOF, with max_n_peaks set to 6.'
    },
    c22_00: {
        label: 'catch22: Histogram Mode (5 bins)',
        shortLabel: 'Histogram mode 5',
        description: 'DN_HistogramMode_5: mode of the z-scored value distribution using 5 histogram bins.'
    },
    c22_01: {
        label: 'catch22: Histogram Mode (10 bins)',
        shortLabel: 'Histogram mode 10',
        description: 'DN_HistogramMode_10: mode of the z-scored value distribution using 10 histogram bins.'
    },
    c22_02: {
        label: 'catch22: First 1/e Autocorrelation',
        shortLabel: 'Autocorr 1/e',
        description: 'CO_f1ecac: first lag where autocorrelation falls below 1/e.'
    },
    c22_03: {
        label: 'catch22: First Autocorrelation Minimum',
        shortLabel: 'Autocorr min',
        description: 'CO_FirstMin_ac: first minimum of the autocorrelation function.'
    },
    c22_04: {
        label: 'catch22: Auto Mutual Information',
        shortLabel: 'Auto MI',
        description: 'CO_HistogramAMI_even_2_5: automutual information at lag 2 using a 5-bin histogram.'
    },
    c22_05: {
        label: 'catch22: Time Reversibility',
        shortLabel: 'Time reversibility',
        description: 'CO_trev_1_num: time-reversibility statistic from successive sample differences.'
    },
    c22_06: {
        label: 'catch22: HRV pNN40',
        shortLabel: 'pNN40',
        description: 'MD_hrv_classic_pnn40: proportion of successive differences larger than 0.04 standard deviations.'
    },
    c22_07: {
        label: 'catch22: Long Stretch Above Mean',
        shortLabel: 'Long stretch high',
        description: 'SB_BinaryStats_mean_longstretch1: longest consecutive run above the mean.'
    },
    c22_08: {
        label: 'catch22: Transition Matrix Covariance',
        shortLabel: 'Transition covariance',
        description: 'SB_TransitionMatrix_3ac_sumdiagcov: diagonal covariance of a 3-symbol transition matrix.'
    },
    c22_09: {
        label: 'catch22: Periodicity',
        shortLabel: 'Periodicity',
        description: 'PD_PeriodicityWang_th0_01: periodicity score using the Wang threshold method.'
    },
    c22_10: {
        label: 'catch22: Embedding Distance Fit',
        shortLabel: 'Embedding distance',
        description: 'CO_Embed2_Dist_tau_d_expfit_meandiff: exponential-fit deviation of 2D embedding distances.'
    },
    c22_11: {
        label: 'catch22: Auto Mutual Info First Minimum',
        shortLabel: 'AMI first min',
        description: 'IN_AutoMutualInfoStats_40_gaussian_fmmi: first minimum of Gaussian automutual information up to lag 40.'
    },
    c22_12: {
        label: 'catch22: Local Prediction Error',
        shortLabel: 'Local pred error',
        description: 'FC_LocalSimple_mean1_tauresrat: local simple mean forecast error using an autocorrelation-based lag.'
    },
    c22_13: {
        label: 'catch22: Positive Outlier Timing',
        shortLabel: 'Positive outliers',
        description: 'DN_OutlierInclude_p_001_mdrmd: timing structure of positive outliers.'
    },
    c22_14: {
        label: 'catch22: Negative Outlier Timing',
        shortLabel: 'Negative outliers',
        description: 'DN_OutlierInclude_n_001_mdrmd: timing structure of negative outliers.'
    },
    c22_15: {
        label: 'catch22: Low-Frequency Power Area',
        shortLabel: 'Low-freq area',
        description: 'SP_Summaries_welch_rect_area_5_1: low-frequency area under the Welch power spectrum.'
    },
    c22_16: {
        label: 'catch22: Long Stretch Below Mean',
        shortLabel: 'Long stretch low',
        description: 'SB_BinaryStats_diff_longstretch0: longest consecutive run of negative successive differences.'
    },
    c22_17: {
        label: 'catch22: Three-Symbol Motif Entropy',
        shortLabel: 'Motif entropy',
        description: 'SB_MotifThree_quantile_hh: entropy of 3-symbol motifs after quantile discretization.'
    },
    c22_18: {
        label: 'catch22: Rescaled Range Fluctuation',
        shortLabel: 'RS fluctuation',
        description: 'SC_FluctAnal_2_rsrangefit_50_1_logi_prop_r1: rescaled-range fluctuation scaling statistic.'
    },
    c22_19: {
        label: 'catch22: DFA Fluctuation',
        shortLabel: 'DFA fluctuation',
        description: 'SC_FluctAnal_2_dfa_50_1_2_logi_prop_r1: detrended fluctuation analysis scaling statistic.'
    },
    c22_20: {
        label: 'catch22: Spectral Centroid',
        shortLabel: 'Spectral centroid',
        description: 'SP_Summaries_welch_rect_centroid: centroid of the Welch power spectrum.'
    },
    c22_21: {
        label: 'catch22: Local Prediction Error (3-point)',
        shortLabel: 'Local pred err 3',
        description: 'FC_LocalSimple_mean3_stderr: local 3-point mean forecast standard error.'
    }
};

export const getFeatureDefinition = (featureId) => {
    const id = String(featureId || '');
    return FEATURE_DEFINITIONS[id] || {
        label: id,
        shortLabel: id,
        description: id
    };
};

export const formatFeatureLabel = (featureId, style = 'label') => {
    const definition = getFeatureDefinition(featureId);
    return definition[style] || definition.label || String(featureId || '');
};

export const withFeatureLabels = (features) => (
    (features || []).map(feature => {
        const id = feature.id || feature.feature_name || feature;
        const definition = getFeatureDefinition(id);
        return {
            ...feature,
            id,
            label: definition.label,
            shortLabel: definition.shortLabel,
            description: definition.description
        };
    })
);
